import axios from "axios";
import React, { useEffect, useState } from "react";
import { SERVER_URL } from "../../constant";
import AlertBox from "../../component/AlertBox";
import { LinearProgress } from "@mui/material";
import { BsThreeDotsVertical } from "react-icons/bs";
import PopOverBox from "../../component/PopOverBox";
import ButtonCompo from "../../component/ButtonCompo";
import { Link } from "react-router-dom";

function AllEmployees() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [employeeData, setEmployeeData] = useState([]);

  //fetch all employee data
  async function getEmployees() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/company/employees/all`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setEmployeeData(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Employees data fetch failed");
    } finally {
      setLoading(false);
    }
  }

  //popover option arrays
  const popoverOprions = [<p className="px-3 py-1">Edit Roles</p>];

  useEffect(() => {
    getEmployees();
  }, []);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Employees
          </h1>
          {employeeData?.length === 0 ? (
            <div>
              <h1 className="text-center text-[20px] font-semibold mt-5 text-slate-400">No employees found</h1>
            </div>
          ) : (
            <div className="w-full mt-5 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-7 gap-5">
              {employeeData?.map((e, i) => (
                <section
                  key={i}
                  className="border flex justify-center items-center flex-col py-2 px-5 rounded-[10px] shadow-md cursor-pointer hover:shadow-lg"
                >
                  <div className="flex justify-between items-center w-full">
                    {e?.adminId !== undefined && e?.adminId?.length > 0 ? (
                      <p className="bg-green-200/70 text-[12px] px-3 py-[2px] rounded-full text-green-800 font-medium">
                        Admin
                      </p>
                    ) : (
                      <p></p>
                    )}
                    {e?.adminId !== undefined && (
                      <PopOverBox
                        trigger={<BsThreeDotsVertical size={"17px"} />}
                        dataArray={[
                          <Link
                            className="px-3 py-1 text-left w-full"
                            to={`/superadmin/employee/settings/role/${e?.adminId}`}
                          >
                            Edit Roles
                          </Link>,
                        ]}
                      />
                    )}
                  </div>
                  <div className="text-center flex flex-col justify-center items-center mt-2">
                    <div className="w-[5rem] h-[5rem]">
                      <img
                        src={`${SERVER_URL}/api/v1/file/view/${e?.logo}`}
                        className="w-full h-full object-cover rounded-full"
                      />
                    </div>
                    <p className="mt-2 font-semibold">{e?.fullName}</p>
                    <p className="text-[15px] font-medium">{e?.role}</p>
                  </div>
                  <div className="text-left w-full mt-2 space-y-1">
                    <p className="text-[15px] text-slate-700">{e?.profEmail}</p>
                    <p className="text-[15px] text-slate-700">
                      {e?.phoneNumber}
                    </p>
                  </div>
                  <div className="flex w-full justify-end items-end">
                    <ButtonCompo href={`/get/employee/${e?._id}`}>
                      See More
                    </ButtonCompo>
                  </div>
                </section>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default AllEmployees;
